import { Link } from "react-router-dom";
import type { Document } from "@/lib/documents";

interface DocumentCardProps {
  doc: Document;
  blurred?: boolean;
}

const VIEWER_TYPE_LABELS: Record<string, string> = {
  slides: "Presentation",
  pdf: "PDF",
  markdown: "Document",
};

export function DocumentCard({ doc, blurred }: DocumentCardProps) {
  const content = (
    <div className="group flex flex-col gap-2 p-4 rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] hover:border-[var(--color-accent)] transition-colors">
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase text-[var(--color-accent)]">
          {doc.id}
        </span>
        <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-wider uppercase text-[var(--color-fg-tertiary)]">
          {VIEWER_TYPE_LABELS[doc.viewerType] ?? doc.viewerType}
        </span>
      </div>
      <h3
        className={`text-[14px] font-[family-name:var(--font-heading)] font-semibold text-[var(--color-fg)] ${blurred ? "blur-[4px] select-none" : ""}`}
      >
        {doc.title}
      </h3>
      <p
        className={`text-[12px] text-[var(--color-fg-secondary)] font-[family-name:var(--font-mono)] leading-relaxed ${blurred ? "blur-[6px] select-none" : ""}`}
      >
        {doc.description}
      </p>
      <div className="flex items-center gap-3 mt-1">
        <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-wider text-[var(--color-fg-tertiary)]">
          {doc.category}
        </span>
        <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-wider text-[var(--color-fg-tertiary)]">
          v{doc.version}
        </span>
        <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-wider text-[var(--color-fg-tertiary)]">
          {doc.date}
        </span>
      </div>
    </div>
  );

  if (blurred) return content;

  return (
    <Link to={`/ir/dataroom/docs/${doc.id}`} className="block">
      {content}
    </Link>
  );
}
